import hljs from "highlight.js/lib/core";
import bash from "highlight.js/lib/languages/bash";  // aliases: sh, zsh
import elm from "highlight.js/lib/languages/elm";
import go from "highlight.js/lib/languages/go";  // aliases: golang
import javascript from "highlight.js/lib/languages/javascript";
import json from "highlight.js/lib/languages/json";
import markdown from "highlight.js/lib/languages/markdown";  // aliases: md
import python from "highlight.js/lib/languages/python";
import rust from "highlight.js/lib/languages/rust";
import shell from "highlight.js/lib/languages/shell";  // aliases: shellsession, console
import sql from "highlight.js/lib/languages/sql";
import xml from "highlight.js/lib/languages/xml";  // aliases: html

hljs.registerLanguage("bash", bash);
hljs.registerLanguage("elm", elm);
hljs.registerLanguage("go", go);
hljs.registerLanguage("javascript", javascript);
hljs.registerLanguage("json", json);
hljs.registerLanguage("markdown", markdown);
hljs.registerLanguage("python", python);
hljs.registerLanguage("rust", rust);
hljs.registerLanguage("shell", shell);
hljs.registerLanguage("sql", sql);
hljs.registerLanguage("xml", xml);

export default hljs;
